// extracted by mini-css-extract-plugin
module.exports = {"projectStyles":"styles_projectStyles__2i5et","contentStyles":"styles_contentStyles__3zXOc","image":"styles_image__9cvJ_"};